import { PrescribeExerciseDto, TreatmentExercise, UpdateExerciseDosageDto } from 'types/models';
import apiClient from './apiClient';

const base = (planId: string) => `/treatment-plans/${planId}/exercises`;

export const treatmentExerciseService = {
  list: async (planId: string): Promise<TreatmentExercise[]> => {
    const { data } = await apiClient.get<TreatmentExercise[]>(base(planId));
    return data;
  },

  prescribe: async (planId: string, payload: PrescribeExerciseDto): Promise<TreatmentExercise> => {
    const { data } = await apiClient.post<TreatmentExercise>(base(planId), payload);
    return data;
  },

  update: async (planId: string, exerciseId: string, payload: UpdateExerciseDosageDto): Promise<TreatmentExercise> => {
    const { data } = await apiClient.patch<TreatmentExercise>(`${base(planId)}/${exerciseId}`, payload);
    return data;
  },

  remove: async (planId: string, exerciseId: string): Promise<void> => {
    await apiClient.delete(`${base(planId)}/${exerciseId}`);
  },
};
